module.exports = __webpack_public_path__ + "static/media/food_pantry.22fb56c0.png";